<template>
  <NuxtLink
    :target="blok?.target ?? ''"
    :to="getPath(blok)"
  >
    <slot />
  </NuxtLink>
</template>

<script setup lang="ts">
  import type ILink from '~/types/Storyblok/Generic/Link'
  import formatSbPath from '~/utils/formatSbPath'

  const { blok } = defineProps<{
    blok: ILink
  }>()

  const { locale } = useI18n()

  function getPath(redirect: any) {
    let slug = ''

    switch (redirect?.linktype) {
      case 'story':
        slug = `/${locale.value}${formatSbPath(
          redirect.story?.full_slug ?? redirect.story?.fullSlug ?? '/',
          locale.value
        )}`
        break
      case 'email':
        slug = `mailto: ${redirect.url}`
        break
      case 'url':
        slug = formatSbPath(redirect.url, locale.value)

        break
    }

    if (redirect?.anchor) {
      slug += `#${redirect.anchor}`
    }

    return slug
  }
</script>
